import Vue from "vue";
import { MutationTree } from "vuex";
import { IExpeditionState } from "./state";
import {
    IExpedition,
    IExpeditionDay,
    IExpeditionAutoControl,
    IExpeditionNotification,
    NotificationType,
    ISlot,
} from "@/models";
import {
    ADD_EXPEDITION_DAY,
    MANAGE_NOTIFICATION,
    ADD_NOTIFICATIONS,
    ADD_NOTIFICATION,
    EDIT_EXPEDITION,
    ADD_EXPEDITION,
    SET_SELECTED_EXPEDITION,
    ADD_AUTOCONTROL_PICTURE,
    ADD_ENDLOAD_PICTURE,
    REMOVE_AUTOCONTROL_PICTURE,
    REMOVE_ENDLOAD_PICTURE,
    CLEAN_EXPEDITION,
    SET_EXPEDITION_AUTOCONTROL,
    SET_SELECTED_NOTIFICATION,
    EDIT_SELECTED_EFFECTIVE_ARRIVAL,
    REMOVE_NOTIFICATION,
    DELETE_EXPEDITION,
    SET_EXPEDITION_START_SLOT,
    SET_EXPEDITION_END_SLOT,
} from "./mutations-types";

export const mutations: MutationTree<IExpeditionState> = {
    [ADD_EXPEDITION_DAY](state, payload: IExpeditionDay): void {
        state.expeditionDay = payload;
    },

    [MANAGE_NOTIFICATION](state, payload: IExpeditionNotification): void {
        let indexToRemove;
        if (payload.type === NotificationType.Appointment) {
            indexToRemove = state.notifications.findIndex(n => n.expedition !== null && n.expedition.expeditionId === payload.expedition.expeditionId);
        } else {
            indexToRemove = state.notifications.findIndex(n => n.askAppointment !== null && n.askAppointment.askAppointmentId === payload.askAppointment.askAppointmentId);
        }

        if (indexToRemove !== -1) {
            state.notifications.splice(indexToRemove, 1);
        } else {
            state.notifications.unshift(payload);
        }
    },

    [ADD_NOTIFICATIONS](state, payload: IExpeditionNotification[]): void {
        state.notifications = state.notifications.concat(payload);
    },

    [ADD_NOTIFICATION](state, payload: IExpeditionNotification): void {
        state.notifications.unshift(payload);
    },

    [EDIT_EXPEDITION](state, payload: IExpedition): void {

        const previousExpeditionDock = state.expeditionDay.docks.find(x => x.dock !== payload.dock && x.expeditions.some(e => e.expeditionId === payload.expeditionId));

        if (previousExpeditionDock) { // if change dock
            const index = previousExpeditionDock.expeditions.findIndex(e => e.expeditionId === payload.expeditionId);

            previousExpeditionDock.expeditions.splice(index, 1);
        }

        const expeditionDock = state.expeditionDay.docks.find(x => x.dock === payload.dock);

        if (expeditionDock) {
            const index = expeditionDock.expeditions.findIndex(e => e !== null && e.expeditionId === payload.expeditionId);

            if (index !== -1) {
                Vue.set(expeditionDock.expeditions, index, payload);
            }
            else {
                expeditionDock.expeditions.push(payload);
            }
        }
        else {
            state.expeditionDay.docks.push({ dock: payload.dock, expeditions: [payload] });
        }
    },

    [ADD_EXPEDITION](state, payload: IExpedition): void {
        const expeditionDock = state.expeditionDay.docks.find(x => x.dock === payload.dock);

        if (expeditionDock) {
            expeditionDock.expeditions.push(payload);
        }
        else {
            state.expeditionDay.docks.push({ dock: payload.dock, expeditions: [payload] });
        }

        // Vue.set(expeditions, payload.dock - 1, payload);
    },

    [SET_SELECTED_EXPEDITION](state, payload: IExpedition): void {
        state.selectedExpedition = payload;
        state.expeditionAutoControl = {
            expeditionAutoControlId: 0,
            clean: true,
            expeditionId: payload.expeditionId,
            floorCondition: true,
            odor: true,
            seal: true,
            stringShoot: true,
            tarpCondition: true,
        };
    },

    [ADD_AUTOCONTROL_PICTURE](state, picture: string): void {
        state.picturesAutoControl.unshift(picture);
    },

    [ADD_ENDLOAD_PICTURE](state, picture: string): void {
        state.picturesEndLoad.unshift(picture);
    },

    [REMOVE_AUTOCONTROL_PICTURE](state, index: number) {
        state.picturesAutoControl.splice(index, 1);
    },

    [REMOVE_ENDLOAD_PICTURE](state, index: number) {
        state.picturesEndLoad.splice(index, 1);
    },

    [CLEAN_EXPEDITION](state) {
        state.picturesAutoControl = [];
        state.picturesEndLoad = [];
        state.selectedExpedition = null;
        state.expeditionAutoControl = null;
        state.selectedNotification = null;
        state.selectedExpedition = null;
    },

    [SET_EXPEDITION_AUTOCONTROL](state, data: IExpeditionAutoControl) {
        state.expeditionAutoControl = data;
    },

    [SET_SELECTED_NOTIFICATION](state, data: IExpeditionNotification) {
        state.selectedNotification = data;
    },

    [EDIT_SELECTED_EFFECTIVE_ARRIVAL](state, effectiveArrival: string) {
        state.selectedExpedition.effectiveArrival = effectiveArrival;
    },

    [REMOVE_NOTIFICATION](state, askAppointmentId: number) {
        const indexToRemove = state.notifications.findIndex(n => n.type === NotificationType.AskAppointment && n.askAppointment.askAppointmentId === askAppointmentId);
        state.notifications.splice(indexToRemove, 1);
    },

    [DELETE_EXPEDITION](state, data: any) {
        const dock = state.expeditionDay.docks.find(x => x.dock === data.dock);

        const index = dock.expeditions.findIndex(x => x.expeditionId === data.expeditionId);

        dock.expeditions.splice(index, 1);
    },

    [SET_EXPEDITION_START_SLOT](state, slot: ISlot) {
        state.expeditionStartSlot = slot;
    },

    [SET_EXPEDITION_END_SLOT](state, slot: ISlot) {
        state.expeditionEndSlot = slot;
    },
};
